import { Controller } from "@hotwired/stimulus"

export function periodFieldState(kind) {
  return {
    yearHidden: kind === "",
    monthHidden: kind !== "monthly",
    yearRequired: kind !== "",
    monthRequired: kind === "monthly"
  }
}

export default class extends Controller {
  static targets = ["kind", "year", "month", "yearField", "monthField"]

  connect() {
    this.sync()
  }

  sync() {
    const state = periodFieldState(this.kindTarget.value)

    this.yearFieldTarget.hidden = state.yearHidden
    this.monthFieldTarget.hidden = state.monthHidden
    this.yearTarget.required = state.yearRequired
    this.monthTarget.required = state.monthRequired
  }
}
